import { LocaleIds } from "models/OrganizationModels/OrganizationMetadataConfiguration";
import {
    CampaignIndicatorType,
    ConcatFieldType,
    ConditionIndicatorType,
    ConditionRuleType,
    HasErrorType,
    KeyFieldType,
    LanguageIndicatorType,
    MappedValueType,
    SourceFieldType,
} from "../types";
import { v4 as uuidv4 } from "uuid";

export const emptyConditionIndicator = (): ConditionIndicatorType => ({
    id: uuidv4(),
    compareType: 0,
    sourceName: "",
    value: "",
    isRequired: false,
    hasError: false,
});

export const emptyCondition = (): ConditionRuleType => ({
    id: uuidv4(),
    targetFieldName: "",
    conditionIndicators: [emptyConditionIndicator()],
    then: {
        id: uuidv4(),
        conditionIndicators: [],
        level: 1,
        hasError: false,
    },
    hasError: false,
    hasTargetFieldError: false,
});

export const emptyMappedValue = (): MappedValueType => ({
    id: uuidv4(),
    targetField: "",
    pairs: [
        {
            sourceValue: "",
            targetValue: "",
            id: uuidv4(),
        },
    ],
});

export const emptyConcatField = (): ConcatFieldType => ({
    id: uuidv4(),
    fields: [],
    targetFieldName: "",
    hasError: false,
});

export const emptyKeyField = (): KeyFieldType => ({
    id: uuidv4(),
    sourceFieldName: "",
    targetFieldName: "",
});

export const emptySourceField = (): SourceFieldType => ({
    id: uuidv4(),
    isRequired: false,
    path: "",
    alias: "",
    extractionPattern: null,
    targetFieldName: "",
});

export const emptyCampaignIndicator = (): CampaignIndicatorType => ({
    id: uuidv4(),
    campaignId: "",
    fieldPath: "",
    comparisonOperator: 0,
    campaignIndicatorStrings: [],
});

export const emptyLanguageIndicator = (): LanguageIndicatorType => ({
    id: uuidv4(),
    localeId: LocaleIds.EN,
    fieldPath: "",
    comparisonOperator: 0,
    languageIndicatorStrings: [],
});

export const defaultHasError: HasErrorType = {
    setup: false,
    sourceFieldsMissing: false,
    sourceFieldsDuplicate: false,
    keyFieldsMissing: false,
    keyFieldsSourceMissingTarget: false,
    keyFieldsCoreSourceAndTarget: false,
};
